export default "__VITE_ASSET__dfa508a1__"